import CorporatePage from '../../components/CorporatePage'
import { CORPORATE_I18N } from '../../data/corporate-i18n'

// Anchor ids match the EXISTING navbar corporate-dropdown hrefs (EN).
const ANCHORS = {
    about: 'about',
    vision: 'vision',
    values: 'values',
    quality: 'quality',
    certifications: 'certificates'
}

const LANG_LINKS = { tr: '/kurumsal', en: '/en/corporate', de: '/de/unternehmen' }

const JSON_LD = {
    '@context': 'https://schema.org',
    '@type': 'AboutPage',
    name: CORPORATE_I18N.en.seo.title,
    description: CORPORATE_I18N.en.seo.description,
    url: 'https://ankaplastik.com/en/corporate',
    inLanguage: 'en',
    about: {
        '@type': 'Organization',
        '@id': 'https://ankaplastik.com/#organization',
        name: 'Ankaplastik'
    }
}

export default function Corporate() {
    return (
        <CorporatePage
            lang="en"
            data={CORPORATE_I18N.en}
            langLinks={LANG_LINKS}
            canonicalUrl="/en/corporate"
            contactHref="/en#contact"
            skipLabel="Skip to content"
            anchors={ANCHORS}
            jsonLd={JSON_LD}
        />
    )
}
